module.exports = __webpack_public_path__ + "img/shelf-a-ico.1e492ae1.png";